module.exports = __webpack_public_path__ + "img/schnittkante_verkehrsgelb_ral1023.0967e7dc.jpg";